var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C4.72386 3 4.5 3.22386 4.5 3.5C4.5 3.77614 4.72386 4 5 4H14C14.2761 4 14.5 3.77614 14.5 3.5C14.5 3.22386 14.2761 3 14 3H5ZM9.85355 5.14645C9.65829 4.95118 9.34171 4.95118 9.14645 5.14645L5.64645 8.64645C5.45118 8.84171 5.45118 9.15829 5.64645 9.35355C5.84171 9.54882 6.15829 9.54882 6.35355 9.35355L9 6.70711V14.5C9 14.7761 9.22386 15 9.5 15C9.77614 15 10 14.7761 10 14.5V6.70711L12.6464 9.35355C12.8417 9.54882 13.1583 9.54882 13.3536 9.35355C13.5488 9.15829 13.5488 8.84171 13.3536 8.64645L9.85355 5.14645Z",
    fill: "#162395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpload);
export default __webpack_public_path__ + "static/media/ArrowUpload.72f62c0d5fa8f266ba0c92b108629208.svg";
export { ForwardRef as ReactComponent };